import { Divider } from "@material-ui/core";
import { Container, Grid } from "@mui/material";
import { optionsNewsType } from "./Components/Contants";
import axios from "axios";
import {
  FormCard,
  FormLabel,
  FormUploadImage,
  ModalError,
  ModalSuccess,
  Page,
  PrimaryButton,
  RadioButtonInput,
  SectionLabel,
  SkeletonComponent,
  TextInput,
} from "components";
import {
  ContentState,
  EditorState,
  convertFromHTML,
  convertToRaw,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { HeaderTitle } from "layouts";
import { useEffect, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { setValueBeritaDanIklan } from "redux/actions/news&ads";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors } from "utils";

const FormNewsAds = () => {
  const classes = globalStyles();
  const history = useHistory();
  const { id } = useParams();
  const newsAds = useSelector(data => data?.newsAds);
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const typeWeb = localStorage.getItem("typeWeb");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const isMpis = typeWeb === "mpis";
  const pageTitle = isMpis
    ? "Finalization"
    : `${id ? "Edit" : "Add"} News & Ads`;
  const editorState = EditorState.createWithContent(
    ContentState.createFromBlockArray(
      htmlToDraft(newsAds.content || "").contentBlocks
    )
  );

  const [loadingPage, setLoadingPage] = useState(false);
  const [payload, setPayload] = useState({
    title: newsAds?.title || "",
    type: newsAds?.type || "berita",
    banner_image: newsAds?.banner_image || null,
  });
  const [textEditor, setTextEditor] = useState(editorState);
  const [imageLogo, setImageLogo] = useState({
    image_url: newsAds?.banner_image || null,
    image: newsAds?.image_blob || null,
  });

  const handleChangePayload = (value, key) => {
    setPayload(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };
  const handlePreview = async () => {
    const rawContentState = convertToRaw(textEditor.getCurrentContent());
    const markup = draftToHtml(rawContentState);
    const previewPayload = {
      title: payload?.title,
      type: payload?.type,
      content: markup,
      banner_image: imageLogo?.image_url || payload?.banner_image,
      image_blob: imageLogo?.image,
    };
    dispatch(setValueBeritaDanIklan(previewPayload));
    history.push(
      `/admin/${
        isMpis
          ? "finalisasi-berita/view"
          : `berita-publisher/${id ? "edit" : "tambah"}`
      }/preview`
    );
  };

  const getDetail = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/article/${id}`, {
        headers,
      });
      const { data } = res?.data;
      setPayload(currentState => ({
        ...currentState,
        title: data?.title,
        type: data?.type,
        banner_image: data?.banner_image,
      }));
      const blocksFromHTML = convertFromHTML(data.content);
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      setTextEditor(EditorState.createWithContent(contentState));
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const handleSubmit = async () => {
    const method = id ? axios.put : axios.post;
    const rawContentState = convertToRaw(textEditor.getCurrentContent());
    const markup = draftToHtml(rawContentState);
    const { title, type, banner_image } = payload;
    const modifiedPayload = {
      title,
      type,
      content: markup,
      ...(imageLogo?.image && { image_logo: imageLogo?.image || banner_image }),
    };
    const formData = new FormData();
    Object.keys(modifiedPayload).forEach(key => {
      formData.append(key, modifiedPayload[key]);
    });
    try {
      setLoadingPage(true);
      await method(
        `${hardBaseUrl}/article${
          id ? `/${isMpis ? `approve/${id}` : id}` : ""
        }`,
        formData,
        { headers }
      );
      ModalSuccess(
        `Successfully ${
          id ? (isMpis ? "approve" : "update") : "save"
        } news & ads`
      ).then(() => history.goBack());
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };

  useEffect(() => {
    if (
      id &&
      (!newsAds?.title || !newsAds?.content || !newsAds?.banner_image)
    ) {
      setLoadingPage(true);
      getDetail();
    }
  }, []);

  return (
    <Page className={classes.root} title={pageTitle}>
      {loadingPage ? (
        <SkeletonComponent variant="wave" />
      ) : (
        <Container maxWidth={false}>
          <HeaderTitle
            title={pageTitle}
            breadcrumbData={breadcrumbData({ pageTitle })}
            backButton
          />
          <Divider className={classes.divider} />
          <SectionLabel title="Cover" subTitle="Add cover/banner for news" />
          <FormCard>
            <FormUploadImage
              label="Banner"
              required
              imageUrl={imageLogo?.image_url || payload?.banner_image}
              setImageLogo={setImageLogo}
              height="200px"
              fileSize={1}
              helperText="Cover format can be images and videos, less than 1MB, 1000 x 500"
            />
          </FormCard>
          <SectionLabel
            title="Content"
            subTitle="Type content of the news here"
          />
          <FormCard>
            <Grid container direction="column" spacing={1}>
              <Grid item>
                <FormLabel label="Title" required />
                <TextInput
                  value={payload?.title}
                  onChange={e => handleChangePayload(e?.target?.value, "title")}
                  placeholder="Title"
                />
              </Grid>
              <Grid item>
                <RadioButtonInput
                  label="Type"
                  required
                  row
                  options={optionsNewsType}
                  value={payload?.type}
                  optionKey="key"
                  optionLabel="label"
                  onChange={e => handleChangePayload(e?.target?.value, "type")}
                />
              </Grid>
              <Grid item>
                <FormLabel label="Contents" required />
                <Editor
                  editorState={textEditor}
                  wrapperClassName="wrapper-class"
                  editorClassName="editor-class input_description"
                  editorStyle={{
                    height: "60vH",
                    backgroundColor: "white",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                  }}
                  toolbarClassName="toolbar-class"
                  wrapperStyle={{
                    border: "1px solid #ccc",
                    paddingLeft: 0,
                    paddingRight: 0,
                  }}
                  toolbar={{
                    options: [
                      "inline",
                      "blockType",
                      "fontSize",
                      "list",
                      "textAlign",
                      "colorPicker",
                      "link",
                      "remove",
                      "history",
                    ],
                  }}
                  onEditorStateChange={setTextEditor}
                />
              </Grid>
            </Grid>
          </FormCard>
          <Grid container justifyContent="flex-end" spacing={1}>
            <Grid item>
              <PrimaryButton label="Preview" onClick={handlePreview} />
            </Grid>
            <Grid item>
              <PrimaryButton
                label={isMpis ? "Save" : "Apply"}
                onClick={handleSubmit}
              />
            </Grid>
          </Grid>
        </Container>
      )}
    </Page>
  );
};

const breadcrumbData = ({ pageTitle }) => [
  {
    label: "Home",
    link: "/admin/dashboard",
  },
  {
    label: "News & Ads",
    link: "/admin/berita-publisher",
  },
  {
    label: pageTitle,
    active: true,
  },
];
export default FormNewsAds;
